import React from "react";
import styles from "./PeopleUI.module.css";
import chrome from "../../../components/common/PageChrome.module.css";
import { personCosts, resourceCosts, WEEKS_PER_MONTH, DEFAULT_WEEKLY_HOURS } from "../../../utils/costUtils";

// The Cost & profit tab: each figure with the sum that produced it, for this calendar month.
export default function CostBreakdown({ entity, kind, formatMoney }) {
  const n = (v) => Number(v) || 0;
  const lines = kind === "person"
    ? (() => {
        const c = personCosts(entity);
        const weekly = entity.default_weekly_hours == null ? DEFAULT_WEEKLY_HOURS : n(entity.default_weekly_hours);
        return [
          ["Cost to company / month", `${formatMoney(n(entity.default_hourly_rate))}/h × ${weekly}h × ${WEEKS_PER_MONTH} weeks`, c.costMonth],
          ["Billed to projects", `${n(entity.month_hours)}h logged × ${formatMoney(n(entity.bill_rate))}/h`, c.billed],
          ["Cost of project hours", `${n(entity.month_hours)}h × ${formatMoney(n(entity.default_hourly_rate))}/h`, c.costToProjects],
          ["Profit / month", "Billed − cost to company", c.profit, c.margin],
        ];
      })()
    : (() => {
        const c = resourceCosts(entity);
        return [
          ["Running cost / month", "Monthly cost", c.costMonth],
          ["Billed to projects", `${n(entity.month_booked_days)} days booked × ${formatMoney(n(entity.bill_rate_day))}/day`, c.billed],
          ["Profit / month", "Billed − running cost", c.profit, c.margin],
        ];
      })();

  return (
    <div className={styles.costTable}>
      {lines.map(([label, how, value, margin]) => (
        <div key={label} className={styles.costLine}>
          <div>
            <div className={styles.costLabel}>{label}</div>
            <div className={chrome.cellSub}>{how}</div>
          </div>
          <div className={value < 0 ? styles.profitNegative : styles.costValue}>
            {formatMoney(value)}
            {margin !== undefined && (
              <span className={chrome.cellSub}>{margin == null ? "Nothing billed yet" : `${Math.round(margin * 100)}% margin`}</span>
            )}
          </div>
        </div>
      ))}
      <p className={chrome.cellSub}>Hours and bookings are for the current calendar month. Every logged timesheet hour counts as billable.</p>
    </div>
  );
}
